/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Order/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Order({
  children,
  viewPath = "/DesignSystem/EditAutomation/EventActions/Content/EventAction/ActionType/Order"
  
}) {
let dtColorsGreen700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.700'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let eventActionItemIndexValueData = fromData.useDataFormat({ viewPath,
context: 'event_action_item',
path: 'index',
format: fromHelpers.getOrder,
})
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
  return (<React.Fragment
>
<div
  data-testid="Order.Vertical"
  data-view-path={viewPath}
 style={{'--bc-1-5vOwY': dtColorsGreen700,'--pr-2-5vOwY': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pl-3-5vOwY': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 color={dtColorsWhite}
 data="event_action_item.index"
 format="helpers.js getOrder"
 text={eventActionItemIndexValueData}
/>
</div>
{children}
</React.Fragment>)
}